import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-bg">
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-content">
        <div className="hero-badge">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="wifi-icon">
            <path d="M12 20h.01M8.5 16.5a5 5 0 017 0M5 13a9 9 0 0114 0M2 9.5C7 4.5 17 4.5 22 9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          No.1 Smart Solutions in Sri Lanka
        </div>
        
        <h1 className="hero-title">
          Make Your Living<br />
          <span className="highlight">Smarter</span>
        </h1>

        <div className="hero-features">
          <div className="feature-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" className="wifi-icon">
              <path d="M12 20h.01M8.5 16.5a5 5 0 017 0M5 13a9 9 0 0114 0M2 9.5C7 4.5 17 4.5 22 9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Expert Team
          </div>
          <div className="feature-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" className="wifi-icon">
              <path d="M12 20h.01M8.5 16.5a5 5 0 017 0M5 13a9 9 0 0114 0M2 9.5C7 4.5 17 4.5 22 9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Leading Smart Home Technology
          </div>
          <div className="feature-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" className="wifi-icon">
              <path d="M12 20h.01M8.5 16.5a5 5 0 017 0M5 13a9 9 0 0114 0M2 9.5C7 4.5 17 4.5 22 9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            End-to-End Control
          </div>
        </div>

        <a href="https://wa.me/+94774641111" className="hero-btn">
          Book a free consultation
        </a>
      </div>
    </section>
  );
};

export default Hero;
